import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@mui/material';
import AddEditForm from './AddEditForm';

function AddEditModal({
  row,
  mode,
  onSave,
  onCancel,
  onDelete,
  open,
  supplierDensityRows,
  ...rest
}) {
  return (
    <Dialog maxWidth="sm" fullWidth onClose={onCancel} open={open} {...rest}>
      {/* Dialog renders its body even if not open */}
      {open && (
        <AddEditForm
          row={row}
          mode={mode}
          onSave={onSave}
          onCancel={onCancel}
          onDelete={onDelete}
          supplierDensityRows={supplierDensityRows}
        />
      )}
    </Dialog>
  );
}

AddEditModal.propTypes = {
  row: PropTypes.object,
  mode: PropTypes.oneOf(['add', 'edit']),
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  onDelete: PropTypes.func,
  open: PropTypes.bool,
  supplierDensityRows: PropTypes.array,
};

AddEditModal.defaultProps = {
  row: {},
  onSave: () => {},
  onCancel: () => {},
  onDelete: () => {},
  open: false,
  supplierDensityRows: [],
};

export default AddEditModal;
